import { useEffect, useState } from "react";

import { getCustomThemes, subscribeToCustomThemes, type CustomThemePalette } from "../themeLibrary";

/**
 * The installed custom-theme library as React state.
 *
 * The library is a localStorage-owned module with its own listener set, not a
 * store, so the hook is a plain subscription: one snapshot on mount, then the
 * module's notifications (including another tab's storage events) re-read it.
 * Consumers only ever render the list; the mutations live on the module so a
 * failed write stays a typed error at the call site instead of hook state.
 */
export function useCustomThemes(): ReadonlyArray<CustomThemePalette> {
  const [themes, setThemes] = useState<ReadonlyArray<CustomThemePalette>>(() => getCustomThemes());

  useEffect(() => {
    setThemes(getCustomThemes());
    return subscribeToCustomThemes(() => {
      setThemes(getCustomThemes());
    });
  }, []);

  return themes;
}
